'use client';
import React, { useState, useEffect } from 'react';
import Image from 'next/image';

const partners = [
  { name: 'Take a Zip Juice', description: 'Premium cold-pressed juice bars across Florida', tag: 'Founding Partner', logo: '/assets/images/takeazip-3d-logo-1779684663776.png' },
  { name: 'Containers by Take a Zip', description: 'Modular container retail & food concepts', tag: 'Distribution Partner', logo: '/assets/images/containers-by-takeazip-logo-1779684653995.png' },
  { name: 'Selfie Rides', description: 'Premium private transportation service', tag: 'Media Partner', logo: '/assets/images/selfierides-logo-blackbackground-1779684672332.png' },
  {
    name: 'BE CEO 3 Group LLC',
    description: 'Business Analysts',
    tag: 'Business Analysts',
    logo: '/assets/images/BE-CEO-3-Group_LLC-3d-1779685646729.png',
  },
];

export default function PartnersSection() {
  const [current, setCurrent] = useState(0);
  const total = partners?.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 3000);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <section id="partners" className="py-20 border-t border-white/6">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-brand-400 uppercase tracking-widest mb-3">Our Network</p>
          <h2 className="font-display text-3xl sm:text-4xl font-800 text-white">
            Trusted Partners
          </h2>
        </div>

        {/* Top: Logo-only Slideshow */}
        <div className="flex justify-center mb-16">
          <div className="glass-card rounded-2xl p-4 max-w-sm w-full">
            <div className="relative w-full aspect-video rounded-xl overflow-hidden bg-black flex items-center justify-center">
              {partners?.map((partner, i) => (
                <div
                  key={partner?.name}
                  className={`absolute inset-0 transition-opacity duration-700 ${i === current ? 'opacity-100' : 'opacity-0'}`}
                >
                  <Image
                    src={partner?.logo}
                    alt={`${partner?.name} logo`}
                    fill
                    sizes="(max-width: 640px) 100vw, 384px"
                    className="object-contain"
                    unoptimized
                  />
                </div>
              ))}
            </div>
            {/* Dots */}
            <div className="flex justify-center gap-2 mt-4">
              {partners?.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`h-2 rounded-full transition-all duration-300 ${i === current ? 'bg-brand-400 w-4' : 'bg-slate-600 w-2'}`}
                  aria-label={`Go to partner ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Bottom: Static Partner Info Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {partners?.map((partner) => (
            <div key={partner?.name} className="glass-card rounded-2xl p-5">
              <span className="chip text-xs mb-3 inline-block">{partner?.tag}</span>
              <h3 className="font-display font-700 text-base text-white mb-1">{partner?.name}</h3>
              <p className="text-sm text-slate-400">{partner?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}